export const LOAD_BOOKS = 'BOOK/LOAD_BOOKS';
export const ADD_BOOK = 'BOOK/ADD_BOOK';
export const REMOVE_BOOK = 'BOOK/REMOVE_BOOK';
export const UPDATE_BOOK = 'BOOK/UPDATE_BOOK';
export const GET_BOOK_BY_ID = "BOOK/GET_BOOK_BY_ID";
export const RESET_BOOK = "BOOK/RESET_BOOK";